import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import { Spinner } from '@cian/ui-kit';
import * as React from 'react';
import classNames from 'classnames';
import * as styles from './Button.css';
export var Button = function Button(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: props.onClick,
    disabled: props.disabled,
    className: classNames(styles['btn'], props.loading && styles['btn-loading'])
  }, props.loading && /*#__PURE__*/React.createElement("div", {
    className: styles['spinner']
  }, /*#__PURE__*/React.createElement(Spinner, {
    size: 16
  })), /*#__PURE__*/React.createElement("span", {
    className: classNames(styles['content'], _defineProperty({}, styles['content-loading'], props.loading))
  }, children));
};